/* tslint:disable */
/* eslint-disable */
/* @relayHash 973df14c7be2fd30cfebd6f74bf0d09e */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type FeaturedCommentsContainerPaginationQueryVariables = {
    count: number;
    cursor?: unknown | null;
    orderBy: COMMENT_SORT;
    storyID?: string | null;
};
export type FeaturedCommentsContainerPaginationQueryResponse = {
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentsContainer_story">;
    } | null;
};
export type FeaturedCommentsContainerPaginationQuery = {
    readonly response: FeaturedCommentsContainerPaginationQueryResponse;
    readonly variables: FeaturedCommentsContainerPaginationQueryVariables;
};



/*
query FeaturedCommentsContainerPaginationQuery(
  $count: Int!
  $cursor: Cursor
  $orderBy: COMMENT_SORT!
  $storyID: ID
) {
  story(id: $storyID) {
    ...FeaturedCommentsContainer_story_32czeo
    id
  }
}

fragment FeaturedCommentContainer_comment on Comment {
  id
  author {
    id
    username
  }
  parent {
    author {
      username
      id
    }
    id
  }
  rating
  body
  createdAt
  replyCount
  ...UsernameWithPopoverContainer_comment
  ...ReactionButtonContainer_comment
  ...MediaSectionContainer_comment
  ...UserTagsContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
}

fragment FeaturedCommentContainer_story on Story {
  url
  commentCounts {
    tags {
      FEATURED
    }
  }
  settings {
    mode
  }
  isArchiving
  isArchived
  ...UserTagsContainer_story
}

fragment FeaturedCommentsContainer_story_32czeo on Story {
  id
  isClosed
  featuredComments(first: $count, after: $cursor, orderBy: $orderBy) {
    edges {
      node {
        id
        ...FeaturedCommentContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PostCommentFormContainer_story
  ...FeaturedCommentContainer_story
  ...ViewersWatchingContainer_story
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  site {
    id
  }
  viewerRating {
    id
    status
    tags {
      code
    }
    rating
  }
  settings {
    messageBox {
      enabled
    }
    experts {
      id
    }
    mode
  }
  ...MessageBoxContainer_story
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}

fragment ViewersWatchingContainer_story on Story {
  id
  viewerCount
  isClosed
  settings {
    live {
      enabled
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "count"
        } as any),
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        } as any),
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orderBy"
        } as any),
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "storyID"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any)
    ], v2 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v4 = [
        ({
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        } as any),
        (v2 /*: any*/)
    ], v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v12 = [
        (v3 /*: any*/)
    ], v13 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": (v12 /*: any*/),
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "FeaturedCommentsContainerPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                (v2 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "FeaturedCommentsContainer_story"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "FeaturedCommentsContainerPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v4 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "featuredComments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "author",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "ignoreable",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "bio",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "parent",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "User",
                                                            "kind": "LinkedField",
                                                            "name": "author",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v3 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v7 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "body",
                                                    "storageKey": null
                                                },
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "replyCount",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentRevision",
                                                    "kind": "LinkedField",
                                                    "name": "revision",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "media",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "title",
                                                                            "storageKey": null
                                                                        },
                                                                        (v10 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "still",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "video",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "GiphyMedia",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v10 /*: any*/)
                                                                    ],
                                                                    "type": "TwitterMedia",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v11 /*: any*/)
                                                                    ],
                                                                    "type": "YouTubeMedia",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "type": "ExternalMedia",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ActionPresence",
                                                    "kind": "LinkedField",
                                                    "name": "viewerActionPresence",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "reaction",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ActionCounts",
                                                    "kind": "LinkedField",
                                                    "name": "actionCounts",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ReactionActionCounts",
                                                            "kind": "LinkedField",
                                                            "name": "reaction",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "total",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v13 /*: any*/),
                                                (v14 /*: any*/),
                                                (v8 /*: any*/),
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "lastViewerAction",
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "cursor",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endCursor",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasNextPage",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v4 /*: any*/),
                            "filters": [
                                "orderBy"
                            ],
                            "handle": "connection",
                            "key": "Stream_featuredComments",
                            "kind": "LinkedHandle",
                            "name": "featuredComments"
                        },
                        (v13 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "viewerRating",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                },
                                (v14 /*: any*/),
                                (v7 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "kind": "LinkedField",
                                    "name": "messageBox",
                                    "plural": false,
                                    "selections": [
                                        (v15 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "content",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "icon",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": (v12 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LiveConfiguration",
                                    "kind": "LinkedField",
                                    "name": "live",
                                    "plural": false,
                                    "selections": [
                                        (v15 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v9 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentCounts",
                            "kind": "LinkedField",
                            "name": "commentCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentTagCounts",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "FEATURED",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchiving",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchived",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerCount",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "973df14c7be2fd30cfebd6f74bf0d09e",
            "metadata": {},
            "name": "FeaturedCommentsContainerPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '44750bdd24128a7793780738c7a9c07f';
export default node;
